// Centralized SVG icon map for Header components (replaces require() calls)
import icoPredio from "../../../assets/img/ico-predio.svg";
import icoDolar from "../../../assets/img/ico-dolar.svg";
import icoViver from "../../../assets/img/ico-viver.svg";
import icoDice from "../../../assets/img/ico-dice.svg";
import icoA from "../../../assets/img/ico-a.svg";
import icoB from "../../../assets/img/ico-b.svg";
import icoT from "../../../assets/img/ico-t.svg";
import icoAssinatura from "../../../assets/img/ico-assinatura.svg";
import icoInvestimento from "../../../assets/img/ico-investimento.svg";
import icoMao from "../../../assets/img/ico-mao.svg";
import icoPasta from "../../../assets/img/ico-pasta.png";
import icoLivro from "../../../assets/img/ico-livro.svg";
import icoFone from "../../../assets/img/ico-fone.svg";
import icoPerson from "../../../assets/img/ico-person.svg";
import icoForm from "../../../assets/img/ico-form.svg";
import icoClose from "../../../assets/img/close.svg";
import logoForluzTexte from "../../../assets/img/logo-forluz-texte.svg";
import lupa from "../../../assets/img/lupa.svg";
import areaDoParticipante from "../../../assets/img/AreaDoParticipante.svg";

export const iconMap: Record<string, string> = {
  "ico-predio.svg": icoPredio,
  "ico-dolar.svg": icoDolar,
  "ico-viver.svg": icoViver,
  "ico-dice.svg": icoDice,
  "ico-a.svg": icoA,
  "ico-b.svg": icoB,
  "ico-t.svg": icoT,
  "ico-assinatura.svg": icoAssinatura,
  "ico-investimento.svg": icoInvestimento,
  "ico-mao.svg": icoMao,
  "ico-pasta.png": icoPasta,
  "ico-livro.svg": icoLivro,
  "ico-fone.svg": icoFone,
  "ico-person.svg": icoPerson,
  "ico-form.svg": icoForm,
  "close.svg": icoClose,
  "logo-forluz-texte.svg": logoForluzTexte,
  "lupa.svg": lupa,
  "AreaDoParticipante.svg": areaDoParticipante,
};

export function getIconSrc(iconName: string | undefined): string | undefined {
  if (!iconName) return undefined;
  return iconMap[iconName];
}